import * as React from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

export const PaginationButton = ({
  label,
  isActive,
  onClick,
  disabled,
  children,
}) => {
  return (
    <>
      {isActive ? (
        <FilledStyledButton onClick={onClick}>
          {label || children}
        </FilledStyledButton>
      ) : (
        <StyledButton disabled={disabled} onClick={onClick}>
          {label || children}
        </StyledButton>
      )}
    </>
  );
};

const StyledButton = styled.button`
  width: 27px;
  height: 27px;
  border: 1px solid ${Colors.brandOne};
  border-radius: 3px;
  background-color: ${Colors.white};
  color: ${(props) => (props.disabled ? "#C4C4C4" : Colors.brandOne)};
  margin-right: 7px;
  font-weight: 400;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

const FilledStyledButton = styled.button`
  width: 27px;
  height: 27px;
  border: 1px solid ${Colors.brandFive};
  border-radius: 3px;
  background-color: ${Colors.white};
  color: ${Colors.brandTwo};
  margin-right: 7px;
  font-weight: 400;
  cursor: pointer;
`;
